import types from './types';

export const initialState = {
  globalCookieIconShown: true,
  open: false,
};

const reducers = {
  [types.SET_COOKIES_SETTINGS_OPEN]: (state, { open }) => ({
    ...state,
    open,
  }),
  [types.SET_GLOBAL_COOKIES_SETTINGS_ICON_SHOWN]: (state, { shown }) => ({
    ...state,
    globalCookieIconShown: shown,
  }),
};

const reducer = (state = initialState, action = {}) => {
  if (reducers[action.type]) {
    return reducers[action.type](state, action);
  }
  return state;
};

export default reducer;
